import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { TVisibilidadeResposta } from '../types/api/bpm/detalhar-processo';

function useUsuarioCorresponde(perfilId: number | null | undefined, usuarioId: string | null | undefined) {
    const { getUserData, possuiPerfilId } = useContext(AuthContext)

    if (getUserData()?.uuid === usuarioId) return true

    return possuiPerfilId(perfilId);
}

export default useUsuarioCorresponde;

export function useVisibilidadeRespostaPerfil(visibilidade: TVisibilidadeResposta, usuarioSolicitante: string) {
    const { getUserData, possuiPerfilId } = useContext(AuthContext)
    let userData = getUserData()

    if (typeof visibilidade?.perfil_ids[1] !== 'string') {
        return false
    }
    if (typeof visibilidade?.perfil_ids[0] !== 'number') {
        return false
    }
    return possuiPerfilId(visibilidade?.perfil_ids[0]) || userData?.nome === usuarioSolicitante;
}
